module.exports = __webpack_public_path__ + "img/toggleTrends.361d1b45.svg";